"use strict";
exports.__esModule = true;
exports.useCancelAccount = void 0;
var use_flex2_api_1 = require("../use-flex2-api");
var v1_routes_1 = require("./v1-routes");
var useCancelAccount = function () {
    var _a = (0, use_flex2_api_1.useFlex2API)({}, { manual: true }), _b = _a[0], data = _b.data, loading = _b.loading, error = _b.error, response = _b.response, execute = _a[1];
    return [
        { data: data, loading: loading, error: error, response: response },
        function (_a) {
            var customerPublicId = _a.customerPublicId, billerAccountPublicId = _a.billerAccountPublicId;
            return execute({
                url: (0, v1_routes_1.cancelAccountRoute)(customerPublicId, billerAccountPublicId),
                method: 'PUT'
            });
        },
    ];
};
exports.useCancelAccount = useCancelAccount;
